import React from 'react';
import classNames from 'classnames';
import './index.less';
import ABSPerfectScrollBar from '../ABSPerfectScrollBar';
import ABSLoading from '../ABSLoading';
import ABSNotSupport from '../ABSNotSupport';
import Min from './Min';
import commonUtils from '../../utils/commonUtils';

interface IABSContainerProps {
  style?: React.CSSProperties;
  className?: string;
  minClassName?: string;
  removePerfectScrollBar?: boolean;
  removePadding?: boolean;
  children: React.ReactNode;
  minWidth?: boolean;
  loading?: boolean;
  isSupport?: boolean;
  notSupportMsg?: string;
  isOnlyMinWidth?: boolean;
}

class ABSContainer extends React.Component<IABSContainerProps> {
  renderMinChildren() {
    const { children, minClassName } = this.props;
    return <Min className={minClassName}>{children}</Min>;
  }

  /**
   * 渲染子组件
   * loading：显示加载组件
   * isSupport: 渲染不支持的组件
   * minWidth : 判断是否是最小宽度
   */
  renderChildren() {
    const { children, minWidth = false, loading, isSupport, notSupportMsg } = this.props;
    if (loading) {
      return <ABSLoading />;
    }
    if (!commonUtils.isNullOrUndefined(isSupport) && !isSupport) {
      return <ABSNotSupport message={notSupportMsg} />;
    }
    if (!minWidth) {
      return children;
    }
    return this.renderMinChildren();
  }

  render() {
    const { className, style, removePerfectScrollBar, removePadding, isOnlyMinWidth = false } = this.props;
    const classes = classNames('abs-container', className, {
      'abs-container-no-padding': removePadding
    });

    if (isOnlyMinWidth) {
      return this.renderMinChildren();
    }

    if (removePerfectScrollBar) {
      return (
        <div className={classes} style={style}>
          {this.renderChildren()}
        </div>
      );
    }

    return (
      <div className={classes} style={style}>
        <ABSPerfectScrollBar>
          <div className="abs-padding-container">{this.renderChildren()}</div>
        </ABSPerfectScrollBar>
      </div>
    );
  }
}

export default ABSContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSContainer/index.tsx